import { Box, Text, Title } from '@mantine/core';

type Props = {
  children?: React.ReactNode;
  title: string;
  description?: string | React.ReactNode;
};

export function PageHeader({ children, title, description }: Props) {
  // 「利用状況」「利用上限設定」はテナントにもプロジェクトにもあるので、どちらを見て
  // いるかを見出しの上に出す。ナビの見出しと同じ語。
  // ルータの hook は使わない: ログイン失敗画面は RouterProvider の外で描画される
  const { pathname } = window.location;
  const scope = pathname.startsWith('/tenant')
    ? 'テナント'
    : pathname.startsWith('/project')
      ? 'プロジェクト'
      : null;

  return (
    <Box mb="xl">
      {scope && (
        <Text className="mt-3" size="xs" fw={700} c="dimmed">
          {scope}
        </Text>
      )}
      <Title order={2} className={scope ? 'mb-6' : 'mt-3 mb-6'}>
        {title}
      </Title>
      <Text className="mb-3" size="sm" maw={640}>
        {description}
      </Text>
      <div>{children}</div>
    </Box>
  );
}
